export const CAR_DEALERS = [
  {
    value: 8,
    label: "Alpina Motors - Av. Libertador 2814 - CABA",
    province: "Ciudad Autónoma de Buenos Aires",
  },
  {
    value: 34,
    label: "Armando Automotores - Av. Tierra del Fuego 2082 - Posadas",
    province: "Misiones",
  },
  {
    value: 58,
    label: "Autodrive - Av. Córdoba 3886 - CABA",
    province: "Ciudad Autónoma de Buenos Aires",
  },
  {
    value: 20,
    label: "Autopremium (Olivos) - Villate 555 - Olivos",
    province: "Buenos Aires",
  },
  {
    value: 21,
    label: "Autopremium (Pilar) - Panamericana Km 52,300 - Ramal Pilar - Pilar",
    province: "Buenos Aires",
  },
  {
    value: 45,
    label: "Autovisiones - Av. Libertador 5750 - CABA",
    province: "Ciudad Autónoma de Buenos Aires",
  },
  {
    value: 11,
    label: "Car Bureau - Av. San Martín 4641 - CABA",
    province: "Ciudad Autónoma de Buenos Aires",
  },
  {
    value: 27,
    label: "Chahín Automotores - Sol de Mayo 1700 - Córdoba",
    province: "Córdoba",
  },
  {
    value: 54,
    label: "CP Motors - Ruta 9 Km 1301 - Yerba Buena",
    province: "Tucumán",
  },
  {
    value: 38,
    label: "Del Norte - Ruta 11 Km 1002.5 - Resistencia",
    province: "Chaco",
  },
  {
    value: 95,
    label: "Dietrich - Jorge Newbery 25 - Bahía Blanca",
    province: "Buenos Aires",
  },
  {
    value: 7,
    label: "Giuvi - Calle 132 N° 520 (entre 43 y 44) - La Plata",
    province: "Buenos Aires",
  },
  {
    value: 2,
    label: "Hiperplatinum - Av. Fuerza Aérea 3742 - Córdoba",
    province: "Córdoba",
  },
  {
    value: 85,
    label: "Javimar Neuquén - Av. Arturo Illia 510 - Neuquén",
    province: "Neuquén",
  },
  {
    value: 40,
    label: "Kijack - Hipolito Yrigoyen 18 - Quilmes",
    province: "Buenos Aires",
  },
  {
    value: 59,
    label: "Kinor Motors - Av. Santa Fe 1581 - Martinez",
    province: "Buenos Aires",
  },
  {
    value: 88,
    label: "Kipercar - San Luis 895 - Pergamino",
    province: "Buenos Aires",
  },
  {
    value: 79,
    label: "Neostar - Pasaje Colidge 1211 - Rosario",
    province: "Santa Fe",
  },
  {
    value: 50,
    label: "Neostar Rosario - Av. Mendoza 4631 - Rosario",
    province: "Santa Fe",
  },
  {
    value: 51,
    label: "Neostar Santa Fe - San Lorenzo 3440 - Santa Fe",
    province: "Santa Fe",
  },
  {
    value: 94,
    label: "Novo Automotores - Perito Francisco Moreno 1917 - Ushuaia",
    province: "Tierra del Fuego",
  },
  {
    value: 98,
    label: "Novo Automotores - Perito Moreno 2597 - Ushuaia",
    province: "Tierra del Fuego",
  },
  {
    value: 9,
    label: "One Saw - Av. Rivadavia 9130 - CABA",
    province: "Ciudad Autónoma de Buenos Aires",
  },
  {
    value: 55,
    label: "Sebastian Bronstein e Hijo - Fray L. Beltrán 2584 - Córdoba",
    province: "Córdoba",
  },
  {
    value: 32,
    label: "Sevek Automotores - Tala 1943 - Concordia",
    province: "Entre Ríos",
  },
  {
    value: 91,
    label: "Surkai - Av. San Martín 598 - Godoy Cruz",
    province: "Mendoza",
  },
];

export const CAR_DEALERS_BY_PROVINCE = [
  {
    id: 34,
    label: "Armando Automotores",
    province: "Misiones",
    direccion: "Av. Uruguay 6132, Posadas, MISIONES",
    horariosDeAtencion:
      "Lunes a Viernes de 10:00hs a 12:30hs / 16:00hs a 20:30hs",
  },
  {
    id: 58,
    label: "Autodrive",
    province: "Ciudad Autónoma de Buenos Aires",
    direccion: "Av. Córdoba 5202, CABA, Buenos Aires",
    horariosDeAtencion: "Lunes a Viernes de 10:00hs a 18:00hs",
  },
  {
    id: 20,
    label: "Autopremium (Olivos)",
    province: "Buenos Aires",
    direccion: "Av. Libertador 2230, Vicente López, Buenos Aires",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 18:30hs y Sábados de 10:00hs a 14:00hs",
  },
  {
    id: 21,
    label: "Autopremium (Pilar)",
    province: "Buenos Aires",
    direccion: "Panamericana Km 52.300, Pilar, Buenos Aires",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 18:30hs y Sábados de 10:00hs a 14:00hs",
  },
  {
    id: 11,
    label: "Car Bureau",
    province: "Ciudad Autónoma de Buenos Aires",
    direccion: "Av. San Martín 4641, CABA, Buenos Aires",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 19:00hs y Sábados de 09:00hs a 14:00hs",
  },
  {
    id: 27,
    label: "Chahín Automotores",
    province: "Córdoba",
    direccion: "Av. Fuerza Aérea Argentina 810, Córdoba",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 13:00hs / 15:30hs a 19:30hs",
  },
  {
    id: 38,
    label: "Del Norte",
    province: "Chaco",
    direccion: "Av. 25 de Mayo 1934, Resistencia, Chaco",
    horariosDeAtencion:
      "Lunes a Viernes de 08:00hs a 12:30hs / 16:30hs a 20:30hs y Sábados de 08:00hs a 12:00hs",
  },
  {
    id: 95,
    label: "Dietrich",
    province: "Buenos Aires",
    direccion: "Jorge Newbery 25, Bahía Blanca, Buenos Aires",
    horariosDeAtencion: "Lunes a Viernes de 09:00hs a 18:00hs",
  },
  {
    id: 7,
    label: "Giuvi",
    province: "Buenos Aires",
    direccion: "Av. 44 (n°)1835, La Plata, Buenos Aires",
    horariosDeAtencion:
      "Lunes a Viernes de 08:00hs a 19:00hs y Sábados de 09:00hs a 14:00hs",
  },
  {
    id: 2,
    label: "Hiperplatinum",
    province: "Córdoba",
    direccion: "Av. Fuerza Aérea 3742, Córdoba",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 18:30hs y Sábados de 09:30hs a 13:00hs",
  },
  {
    id: 40,
    label: "KiJack",
    province: "Buenos Aires",
    direccion: "Av. Hipolito Yrigoyen 18, Quilmes, Buenos Aires",
    horariosDeAtencion:
      "Lunes a Viernes de 08:00hs a 13.00hs / 14.00hs a 18.00hs",
  },
  {
    id: 59,
    label: "Kinor Motors",
    province: "Buenos Aires",
    direccion: "Av. Santa Fe 1007, Martínez, Buenos Aires",
    horariosDeAtencion: "Lunes a Sábados de 09:00hs a 20:00hs",
  },
  {
    id: 50,
    label: "Neostar Rosario",
    province: "Santa Fe",
    direccion: "Av. Mendoza 4631, Rosario, Santa Fe",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 19:00hs y Sábados de 09:00hs a 13:00hs",
  },
  {
    id: 51,
    label: "Neostar Santa fe",
    province: "Santa Fe",
    direccion: "Av. Alem y Sarmiento (Puerto), Sta. Fe, Santa Fe",
    horariosDeAtencion:
      "Lunes a Viernes de 09:00hs a 17:00hs y Sábados de 09:30hs a 13:00hs",
  },
  {
    id: 98,
    label: "Novo Automotores (Río Grande)",
    province: "Tierra del Fuego",
    direccion: "Av. San Martín 2427, Rio Grande, Tierra del Fuego",
    horariosDeAtencion:
      "Lunes a Viernes de 10:00hs a 13:00hs / 15:00hs a 20:00hs y Sábados de 10:00hs a 13:00hs",
  },
  {
    id: 9,
    label: "One Saw",
    province: "Ciudad Autónoma de Buenos Aires",
    direccion: "Av. Rivadavia 9130, CABA, Bs.As.",
    horariosDeAtencion: "Lunes a Viernes de 10:00hs a 19:00hs",
  },
  {
    id: 32,
    label: "Sevek Automotores",
    province: "Entre Ríos",
    direccion: "Mendiburu 91, Concordia, Entre Ríos",
    horariosDeAtencion:
      "Lunes a Viernes de 08:30hs a 13:00hs / 16:00hs a 20:00hs",
  },
  {
    id: 91,
    label: "Surkai",
    province: "Mendoza",
    direccion: "Av. San Martín 598, Godoy Cruz, Mendoza",
    horariosDeAtencion:
      "Lunes a Viernes de 08:30hs a 13:00hs / 16:30hs a 20:30hs",
  },
];
